import React, { useState, useEffect } from 'react';
import Spectrum from 'react-spectrum';
import generateColors from './utils/generateColors';
import getRandomInRange from './utils/getRandomInRange';
import SpectrumCode from './SpectrumCode';
import { JSONUncrush, JSONCrush } from './JSONCrush';

const getConfigFromURL = () => {
  const url = new URL(window.location.href);
  return url.searchParams.get('config');
};

/* eslint-disable react/prop-types */
const RenderSpectrum = ({
  lightBackground,
  generateNew,
  toggleLightMode,
  readConfigFromURL,
}) => {
  /* eslint-enable react/prop-types */
  const [config] = useState(() => {
    const generateConfig = () => {
      const colors = generateColors({
        rotation: getRandomInRange(0, 360),
        lightBackground,
      });
      const wordWidths = [20, 30, 40, 50, 60];

      return {
        width: 500,
        colors: colors.map(c => c.hex).splice(0, getRandomInRange(4, 9)),
        wordWidths,
        wordDistances: [
          getRandomInRange(2, 4),
          getRandomInRange(4, 6),
          getRandomInRange(6, 8),
        ],
        lineDistance: getRandomInRange(4, 12),
        paragraphDistance: getRandomInRange(8, 24),
        paragraphs: getRandomInRange(1, 2),
        linesPerParagraph: getRandomInRange(3, 6),
        wordHeight: getRandomInRange(6, 14),
        wordRadius: [0, 2, 4, 6, 8, 10, 12, 16, 20, Math.max(...wordWidths)][
          getRandomInRange(0, 9)
        ],
        truncateLastLine: [true, false][getRandomInRange(0, 1)],
      };
    };

    const conf = getConfigFromURL();
    if (readConfigFromURL && conf) {
      try {
        return JSON.parse(JSONUncrush(decodeURIComponent(conf)));
      } catch (err) {
        return generateConfig();
      }
    } else {
      return generateConfig();
    }
  });

  useEffect(() => {
    // Expose config in window for external consumption
    // eslint-disable-next-line no-underscore-dangle
    window.__SPECTRUM_CONFIG = { ...config };

    // Update URL
    const queryParams = [
      `config=${JSONCrush(JSON.stringify(config))}`,
      lightBackground ? `light=1` : '',
      // Twitter ignores * at the end of the URL
      // Always add a extra parameter to avoid this issue
      `_=_`,
    ].filter(Boolean);
    window.history.replaceState(
      null,
      document.title,
      `/?${queryParams.join('&')}`,
    );
  }, [config, lightBackground]);

  return (
    <>
      <div
        className="canvas"
        id="canvas"
        style={{ background: lightBackground ? '#f3f8f9' : '#0f0f10' }}>
        <div className="spectrum">
          <div
            style={{
              marginBottom:
                -1 * Math.max(config.lineDistance, config.paragraphDistance),
            }}>
            <Spectrum {...config} />
          </div>
        </div>
      </div>
      <div>
        <small>
          Press <b>Space</b> to generate a new one and <b>E</b> to toggle light
          mode
        </small>
      </div>
      <div className="button-wrapper">
        <button className="button" onClick={generateNew}>
          Generate
        </button>
        <button className="button" onClick={toggleLightMode}>
          Toggle light mode
        </button>
      </div>
      <div>
        <h2>
          <b>Code</b> 👇
        </h2>
        <SpectrumCode config={config} />
      </div>
    </>
  );
};

export default RenderSpectrum;
